<template>
  <div>
    <!-- <PageTitle :title="$t('global.cloud-servers')" /> -->
    <router-view />
    <!-- TODO: Insert list of cloud servers -->
  </div>
</template>

<script>
// import { computed, onMounted } from "@vue/composition-api";
// import constants from "@/utils/constants";
// import NavLink from "@/classes/NavLink";
// import PageTitle from "@/components/display/PageTitle";
// import store from "@/store";

export default {
  name: "CloudServersPage",
  components: {
    // PageTitle,
  },
  setup() {
    // const cloudServers = computed(() => store.state.cloudServers.list);

    // onMounted(() => {
    // TODO: add store for cloud servers
    // store.dispatch("cloudServers/fetch");
    // store.dispatch("nav/setBreadcrumbs", [
    //   new NavLink(context.root.$t("global.home"), null, constants.HOME_ROUTE),
    //   new NavLink(context.root.$t("global.cloud-servers"), null, "cloud-servers"),
    // ]);
    // });
    return {
      // cloudServers,
    };
  },
};
</script>
